import React from "react";
import "./ProductModal.css";


const ProductModal=({
product,
closeModal
})=>{

const website  = product.website_url || '#'
const features = Array.isArray(product.features) ? product.features : []

return(

<div className="modal-backdrop" onClick={closeModal}>


<div className="product-modal" onClick={e => e.stopPropagation()}>


<button 
className="close-btn"
onClick={closeModal}
>
×
</button>



<h2>
{product.name}
</h2>

{product.tagline && <p className='product-modal-tagline'>{product.tagline}</p>}


<h4>
About
</h4>

<p>
{product.description}
</p>


{product.how_it_works && (
<>
<h4>
How It Works
</h4>

<p>
{product.how_it_works}
</p>
</>
)}


{features.length > 0 && (
<>
<h4>
Features
</h4>


<ul>

{
features.map(
(feature,index)=>(

<li key={index}>
{feature}
</li>

))
}

</ul>
</>
)}



<a
href={website}
target='_blank'
rel='noreferrer'
className="explore-btn"
>

Explore Product

</a>


</div>


</div>


)

}


export default ProductModal;